import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import LoadingScreen from "@/components/loading/LoadingScreen.vue";
import MessageHandlersProvider from "@/components/provider/MessageHandlersProvider.vue";
import Snackbar from "@/components/snackbar/Snackbar.vue";
import PopupContainer from "@/components/popup/PopupContainer.vue";
import { useComputedValue, useLoadAppProperties } from "@/composables";
import RingingCallsContainer from "./components/call/RingingCallsContainer/RingingCallsContainer.vue";
import CallRoom from "./components/call/CallRoom/CallRoom.vue";
import { GetterTypes } from "./store";
import { IOngoingCall } from "./store/auth/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { isAppLoading, popupType } = useLoadAppProperties();
const ongoingCall = useComputedValue<IOngoingCall>(
  GetterTypes.GET_CURRENT_ONGOING_CALL,
);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(MessageHandlersProvider, null, {
    default: _withCtx(() => [
      (!!_unref(ongoingCall))
        ? (_openBlock(), _createBlock(CallRoom, { key: 0 }))
        : (_openBlock(), _createBlock(_component_router_view, { key: 1 }, {
            default: _withCtx(({ Component }) => [
              (_openBlock(), _createBlock(_KeepAlive, { max: "1" }, [
                (!_unref(isAppLoading))
                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                      key: _ctx.$route.path
                    }))
                  : _createCommentVNode("", true)
              ], 1024))
            ]),
            _: 1
          })),
      (_unref(isAppLoading))
        ? (_openBlock(), _createBlock(LoadingScreen, { key: 2 }))
        : _createCommentVNode("", true),
      (!_unref(isAppLoading) && _unref(popupType))
        ? (_openBlock(), _createBlock(PopupContainer, { key: 3 }))
        : _createCommentVNode("", true),
      _createVNode(Snackbar),
      _createVNode(RingingCallsContainer)
    ]),
    _: 1
  }))
}
}

})